import { useEffect } from "react";
import { useAxiosGet } from "./useAxiosGet";
import connectWebSocket from "../WebSocketClient";
import { useCollection } from "./useCollection";

export const useCompaniesQuery = (url, params = {}, enabled = true) => {


    const {
        items: companies,
        loading,
        addItem: addCompany,
        updateItem: updateCompany
    } = useCollection(url, params, enabled);

    useEffect(() => {
        const clientEvaluate = connectWebSocket('empresa/evaluarEmpresa', (dato) => {
            updateCompany(dato.empresaId, { estaAprobado: dato.estaAprobado });
        });
        const clientRegister = connectWebSocket('empresa/nuevoRegistro', (company) => {
            addCompany(company);
        });

        return () => {
            clientEvaluate?.deactivate?.();
            clientRegister?.deactivate?.();
        };
    }, [])

    return {
        companies,
        loading,
        updateCompany
    };
};
